import { render, staticRenderFns } from "./ChromosomeMap.vue?vue&type=template&id=58e0fc0f&scoped=true"
import script from "./ChromosomeMap.vue?vue&type=script&lang=js"
export * from "./ChromosomeMap.vue?vue&type=script&lang=js"
import style0 from "./ChromosomeMap.vue?vue&type=style&index=0&id=58e0fc0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e0fc0f",
  null
  
)

export default component.exports